import React, { useState } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import config from "../config";

const baseUrl = config.baseURL;
const ChangePassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");

  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    const passwordStrengthRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    if (!passwordStrengthRegex.test(newPassword)) {
      setError(
        "Password must be at least 8 characters long and contain 1 uppercase, 1 lowercase, and 1 digit."
      );
      return;
    }

    setLoading(true);
    setError("");

    try {
      const token = localStorage.getItem("token");

      if (!token) {
        setError("Reset token not found.");
        return;
      }

      if (token) {
        let response = await axios.post(
          `${baseUrl}/api/profile/changePassword`,
          { currentPassword, newPassword },
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the header
            },
          }
        );
        if (response) {
          setSuccess(true);
          if (response.token) {
            localStorage.setItem("Token", response.token); // store the new token if provided
          }
        }
      }
    } catch (err) {
      console.error("Error during password reset:", err);
      setError("Failed to reset password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#F5F5F5", // Light background
        fontFamily: "Roboto, sans-serif",
        padding: "30px",
        textAlign: "center",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          fontWeight: "600",
          marginBottom: "24px",
          color: "#34495E", // Dark color for header
        }}
      >
        Reset Your Password
      </Typography>

      {success ? (
        <Alert severity="success" sx={{ marginBottom: "20px" }}>
          Password has been reset successfully! You can now log in with your new
          password.
        </Alert>
      ) : (
        <>
          {error && (
            <Alert severity="error" sx={{ marginBottom: "20px" }}>
              {error}
            </Alert>
          )}

          <form
            onSubmit={handleSubmit}
            style={{
              width: "100%",
              maxWidth: "450px",
              backgroundColor: "#fff",
              padding: "30px",
              borderRadius: "10px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            <TextField
              label="Current Password"
              type="password"
              variant="outlined"
              fullWidth
              required
              sx={{
                marginBottom: "16px",
                backgroundColor: "#FAFAFA", // Light background for input fields
                borderRadius: "8px",
              }}
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
            />
            <TextField
              label="New Password"
              type="password"
              variant="outlined"
              fullWidth
              required
              sx={{
                marginBottom: "16px",
                backgroundColor: "#FAFAFA", // Light background for input fields
                borderRadius: "8px",
              }}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <TextField
              label="Confirm Password"
              type="password"
              variant="outlined"
              fullWidth
              required
              sx={{
                marginBottom: "24px",
                backgroundColor: "#FAFAFA", // Light background for input fields
                borderRadius: "8px",
              }}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />

            <Button
              variant="contained"
              fullWidth
              type="submit"
              sx={{
                padding: "12px",
                fontSize: "16px",
                borderRadius: "8px",
                backgroundColor: "#34495E",

                "&:hover": { backgroundColor: "#5D6D7E" },
              }}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="#34495E" />
              ) : (
                "Reset Password"
              )}
            </Button>
          </form>
        </>
      )}

      {!success && (
        <Button
          variant="text"
          color="secondary"
          sx={{
            marginTop: "20px",
            fontWeight: "600",
            color: "#34495E", // Styling for the button
          }}
          onClick={() => navigate("/login")}
        >
          Go Back to Login
        </Button>
      )}
    </Box>
  );
};

export default ChangePassword;
